module.exports = __webpack_public_path__ + "static/media/108.992daa23.jpg";